<template>
  <div class="profile-container">

    <div class="fixed-edit-options">
      <b-row class="mx-2 my-1 justify-content-center">
        <b-col class="mr-1 d-flex justify-content-center align-items-center">
          <div class="editOptions d-flex justify-content-center">
            <b-button variant="primary" size="md" :disabled="editProfile.disabled" @click="updateProfiles()"
              style="margin-right: 10px;">
              {{ editProfile.text }}
            </b-button>
            <b-button variant="danger" size="md" :disabled="editProfile.disabled" @click="$emit('cancelProfile')">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>

    <div v-for="(profile, index) in institutionUsersCompleteData" :key="profile.id" class="student-profile">
      <div class="border border-info my-5 no-print"></div>
      <h3 class="mr-1">Student {{ index + 1 }}:</h3>

      <!-- Academic info -->

      <div class="section-container">
        <b-row align-v="center" class="section-header">
          <b-col md="12">
            <h3 class="section-title text-info"><i class="fas fa-university"></i> Academic Info
            </h3>
          </b-col>
        </b-row>
        <b-row align-v="center" class="section-content mb-1">
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Admission Number</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-input v-model="profile.admission_no" type="text" class="ml-2 input-field" required />
            </div>
          </b-col>
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Date of Joining</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-input v-model="profile.date_of_joining" type="date" class="ml-2 input-field" required />
            </div>
          </b-col>
        </b-row>
        <b-row align-v="center" class="section-content mb-1">
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Category of Admission</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-select v-model="profile.category_of_admission" :options="AdmissionCategories"
                class="ml-2 input-field" required />
            </div>
          </b-col>
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Entrance Rank</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-input v-model="profile.entrance_rank" class="ml-2 input-field" required />
            </div>
          </b-col>
        </b-row>
        <b-row align-v="center" class="section-content mb-1">
          <!-- Programme Field -->
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Programme</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-input v-model="userSubGroup.usergroup.name" :disabled="true" type="text" class="ml-2 input-field"
                required />
            </div>
          </b-col>
          <!-- Branch Field -->
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Branch</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-input v-model="userSubGroup.usergroup.maingroup.name" :disabled="true" type="text"
                class="ml-2 input-field" required />
            </div>
          </b-col>
        </b-row>
        <b-row align-v="center" class="section-content mb-1">
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Register Number</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-input v-model="profile.register_no" type="text" class="ml-2 input-field" required />
            </div>
          </b-col>
        </b-row>
      </div>

      <!-- Personal Details Section -->

      <div class="section-container">
        <b-row align-v="center" class="section-header">
          <b-col md="12">
            <h3 class="section-title text-info"><i class="fas fa-user"></i> Personal Details</h3>
          </b-col>
        </b-row>
        <b-row align-v="center" class="section-content mb-1">
          <!-- First Name -->
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">First Name</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-input v-model="profile.first_name" placeholder="Enter Name" class="ml-2 input-field" required />
            </div>
          </b-col>
          <!-- Last Name -->
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Last Name</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-input v-model="profile.last_name" placeholder="Enter Name" class="ml-2 input-field" required />
            </div>
          </b-col>
        </b-row>
        <b-row align-v="center" class="section-content mb-1">
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Gender</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-select v-model="profile.gender" :options="genders" class="ml-2 input-field" required />
            </div>
          </b-col>
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Blood Group</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-select v-model="profile.blood_group" :options="bloodgroups" class="ml-2 input-field" required />
            </div>
          </b-col>
        </b-row>
        <!-- Date of Birth and Aadhaar Number in the same row -->
        <b-row align-v="center" class="section-content mb-1">
          <!-- Date of Birth -->
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Date of Birth</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-input v-model="profile.birth_date" type="date" class="ml-2 input-field" required />
            </div>
          </b-col>
          <!-- Aadhaar Number -->
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Aadhaar Number</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-input v-model="profile.aadhaar_card_no" placeholder="Enter Aadhaar Number"
                class="ml-2 input-field" required />
            </div>
          </b-col>
        </b-row>
        <!-- Religion and Caste -->
        <b-row align-v="center" class="section-content mb-1">
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Religion</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-select v-model="profile.religion" @change="updateCastes(index)" :options="religions"
                class="ml-2 input-field" required />
            </div>
          </b-col>
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Caste</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-select v-model="profile.caste"
                :options="profile.castes && profile.castes.length > 0 ? profile.castes : castes"
                class="ml-2 input-field" required />
            </div>
          </b-col>
        </b-row>
        <!-- Category of Admission and Blood Group -->
        <b-row align-v="center" class="section-content mb-1">
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Reservation Category</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-select v-model="profile.reservation_category" :options="reservationCategories" class="ml-2 input-field" required />
            </div>
          </b-col>
        </b-row>
        <!-- Permanent Address Section -->
        <b-row align-v="center" class="section-content mb-1">
          <b-col md="12">
            <h4 class="text"><b><u>Permanent Address :</u></b></h4>
          </b-col>
        </b-row>
        <b-row align-v="center" class="section-content mb-1">
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">House Name/Apartment Name</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-input v-model="profile.house_name_permanent_address" class="ml-2 input-field" required />
            </div>
          </b-col>
          <!-- Town/Locality -->
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Town/Locality</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-input v-model="profile.town_permanent_address" class="ml-2 input-field" required />
            </div>
          </b-col>
        </b-row>
        <b-row align-v="center" class="section-content mb-1">
          <!-- Pincode -->
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Pincode</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-input v-model="profile.pincode_permanent_address" class="ml-2 input-field" required />
            </div>
          </b-col>
          <!-- Country -->
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Permanent Country</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-select v-model="profile.country_permanent_address" :options="countries" class="ml-2 input-field"
                @change="updatePermanentStates(index)" required />
            </div>
          </b-col>
        </b-row>

        <!-- Permanent State -->
        <b-row align-v="center" class="section-content mb-1">
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Permanent State</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-select v-model="profile.state_permanent_address"
                :options="profile.permanentStates && profile.permanentStates.length > 0 ? profile.permanentStates : states"
                class="ml-2 input-field" @change="updatePermanentDistricts(index)" required />
            </div>
          </b-col>

          <!-- Permanent District -->
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Permanent District</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-select v-model="profile.district_permanent_address"
                :options="profile.permanentdistricts && profile.permanentdistricts.length > 0 ? profile.permanentdistricts : districts"
                class="ml-2 input-field" required />
            </div>
          </b-col>
        </b-row>
        <!-- Communication Address Section -->
        <b-row align-v="center" class="section-content mb-1">
          <b-col md="12">
            <h4 class="text"><b><u>Communication Address :</u></b></h4>
          </b-col>
        </b-row>
        <b-row align-v="center" class="section-content mb-1">
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">House Name/Apartment Name</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-input v-model="profile.house_name_communication_address" class="ml-2 input-field" required />
            </div>
          </b-col>
          <!-- Town/Locality -->
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Town/Locality</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-input v-model="profile.town_communication_address" class="ml-2 input-field" required />
            </div>
          </b-col>
        </b-row>
        <b-row align-v="center" class="section-content mb-1">
          <!-- Pincode -->
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Pincode</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-input v-model="profile.pincode_communication_address" class="ml-2 input-field" required />
            </div>
          </b-col>
          <!-- Country -->
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Country</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-select v-model="profile.country_communication_address" :options="countries"
                class="ml-2 input-field" @change="updateCommunicationStates(index)" required />
            </div>
          </b-col>
        </b-row>
        <b-row align-v="center" class="section-content mb-1">
          <!-- State -->
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">State</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-select v-model="profile.state_communication_address"
                :options="profile.communicationStates && profile.communicationStates.length > 0 ? profile.communicationStates : states"
                class="ml-2 input-field" @change="updateCommunicationDistricts(index)" required />
            </div>
          </b-col>
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">District</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-select v-model="profile.district_communication_address"
                :options="profile.communicationdistricts && profile.communicationdistricts.length > 0 ? profile.communicationdistricts : districts"
                class="ml-2 input-field" required />
            </div>
          </b-col>
        </b-row>
        <b-row align-v="center" class="section-content mb-1">
          <!-- Mobile Number -->
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Mobile Number</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-input v-model="profile.mobile" type="tel" placeholder="Enter mobile number"
                class="ml-2 input-field" required />
            </div>
          </b-col>
          <!-- Email -->
          <b-col md="2">
            <div class="d-flex align-items-center">
              <div class="label font-weight-bold">Email</div>
            </div>
          </b-col>
          <b-col md="4">
            <div class="d-flex align-items-center">
              <b-form-input v-model="profile.email" type="email" placeholder="Enter email" class="ml-2 input-field"
                required />
            </div>
          </b-col>
        </b-row>
      </div>

      <!-- Guardian/Parent Details -->

      <div class="section-container">
        <b-row align-v="center" class="section-header">
          <b-col md="12">
            <h3 class="section-title text-info" style="display: flex; align-items: center;">
              <i class="fas fa-user-shield"></i> Guardian/Parent Details
              <i class="fas fa-plus-circle" style="cursor: pointer; margin-left: 10px;" @click="addGuardian(index)"></i>
            </h3>
          </b-col>
        </b-row>
        <b-row v-if="profile.guardians && profile.guardians.length > 0" align-v="center" class="section-content mb-1">
          <b-col md="12">
            <table class="table table-striped table-bordered">
              <thead class="thead-dark text-left">
                <tr>
                  <th>Name</th>
                  <th>Relationship</th>
                  <th>Education</th>
                  <th>Occupation</th>
                  <th>Annual Income</th>
                  <th>Mobile Number</th>
                  <th>Email</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(guardian, gIndex) in profile.guardians" :key="gIndex">


                  <td>
                    <input v-model="guardian.name" type="text" class="form-control" placeholder="Enter Name" />
                  </td>
                  <td>
                    <b-form-select v-model="guardian.relationship" :options="guardianSiblingsRelationships"
                      class="ml-2 input-field" required />
                  </td>
                  <td>
                    <input v-model="guardian.education" type="text" class="form-control"
                      placeholder="Enter Education" />
                  </td>
                  <td>
                    <input v-model="guardian.occupation" type="text" class="form-control"
                      placeholder="Enter Occupation" />
                  </td>
                  <td>
                    <input v-model="guardian.annual_income" type="text" class="form-control"
                      placeholder="Enter Annual Income" />
                  </td>
                  <td>
                    <input v-model="guardian.phone_number" type="text" class="form-control"
                      placeholder="Enter Mobile Number" />
                  </td>
                  <td>
                    <input v-model="guardian.email" type="text" class="form-control" placeholder="Enter email" />
                  </td>
                  <td class="text-center">
                    <span class="text-danger btn p-0" @click="removeGuardian(index, gIndex)">
                      <i class="fas fa-minus-circle" style="font-size: 16px;"></i>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col md="12">
            <table class="table table-striped table-bordered">
              <thead class="thead-dark text-left">
                <tr>
                  <th>Name</th>
                  <th>Relationship</th>
                  <th>Education</th>
                  <th>Occupation</th>
                  <th>Annual Income</th>
                  <th>Mobile Number</th>
                  <th>Email</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input @click="addGuardian(index)" type="text" class="form-control" placeholder="Enter Name" />
                  </td>
                  <td>
                    <b-form-select @click="addGuardian(index)" :options="guardianSiblingsRelationships"
                      class="ml-2 input-field" required />
                  </td>
                  <td>
                    <input @click="addGuardian(index)" type="text" class="form-control" placeholder="Enter Education" />
                  </td>
                  <td>
                    <input @click="addGuardian(index)" type="text" class="form-control"
                      placeholder="Enter Occupation" />
                  </td>
                  <td>
                    <input @click="addGuardian(index)" type="text" class="form-control"
                      placeholder="Enter Annual Income" />
                  </td>
                  <td>
                    <input @click="addGuardian(index)" type="text" class="form-control"
                      placeholder="Enter Mobile Number" />
                  </td>
                  <td>
                    <input @click="addGuardian(index)" type="text" class="form-control"
                      placeholder="Enter Email" />
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </div>

      <!-- Siblings Details -->

      <div class="section-container">
        <b-row align-v="center" class="section-header">
          <b-col md="12">
            <h3 class="section-title text-info" style="display: flex; align-items: center;">
              <i class="fas fa-user-friends"></i> Siblings Details
              <i class="fas fa-plus-circle" style="cursor: pointer; margin-left: 10px;" @click="addSiblings(index)"></i>
            </h3>
          </b-col>
        </b-row>

        <b-row v-if="profile.siblings && profile.siblings.length > 0" align-v="center" class="section-content mb-1">
          <b-col md="12">
            <table class="table table-striped table-bordered">
              <thead class="thead-dark text-left">
                <tr>
                  <th>Name</th>
                  <th>Relationship</th>
                  <th>Education</th>
                  <th>Occupation</th>
                  <th>Annual Income</th>
                  <th>Mobile Number</th>
                  <th>Email</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(siblings, sIndex) in profile.siblings" :key="sIndex">
                  <td>
                    <input v-model="siblings.name" type="text" class="form-control" placeholder="Enter Name" />
                  </td>
                  <td>
                    <b-form-select v-model="siblings.relationship" :options="guardianSiblingsRelationships"
                      class="ml-2 input-field" required />
                  </td>
                  <td>
                    <input v-model="siblings.education" type="text" class="form-control"
                      placeholder="Enter Education" />
                  </td>
                  <td>
                    <input v-model="siblings.occupation" type="text" class="form-control"
                      placeholder="Enter Occupation" />
                  </td>
                  <td>
                    <input v-model="siblings.annual_income" type="text" class="form-control"
                      placeholder="Enter Annual Income" />
                  </td>
                  <td>
                    <input v-model="siblings.phone_number" type="text" class="form-control"
                      placeholder="Enter Mobile Number" />
                  </td>
                  <td>
                    <input v-model="siblings.email" type="text" class="form-control" placeholder="Enter email" />
                  </td>
                  <td class="text-center">
                    <span class="text-danger btn p-0" @click="removeSiblings(index, sIndex)">
                      <i class="fas fa-minus-circle" style="font-size: 16px;"></i>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>

        <b-row v-else>
          <b-col md="12">
            <table class="table table-striped table-bordered">
              <thead class="thead-dark text-left">
                <tr>
                  <th>Name</th>
                  <th>Relationship</th>
                  <th>Education</th>
                  <th>Occupation</th>
                  <th>Annual Income</th>
                  <th>Mobile Number</th>
                  <th>Email</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input @click="addSiblings(index)" type="text" class="form-control" placeholder="Enter Name" />
                  </td>
                  <td>
                    <b-form-select @click="addSiblings(index)" :options="guardianSiblingsRelationships"
                      class="ml-2 input-field" required />
                  </td>
                  <td>
                    <input @click="addSiblings(index)" type="text" class="form-control" placeholder="Enter Education" />
                  </td>
                  <td>
                    <input @click="addSiblings(index)" type="text" class="form-control"
                      placeholder="Enter Occupation" />
                  </td>
                  <td>
                    <input @click="addSiblings(index)" type="text" class="form-control"
                      placeholder="Enter Annual Income" />
                  </td>
                  <td>
                    <input @click="addSiblings(index)" type="text" class="form-control"
                      placeholder="Enter Mobile Number" />
                  </td>
                  <td>
                    <input @click="addSiblings(index)" type="text" class="form-control"
                      placeholder="Enter Email" />
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </div>

    </div>
  </div>
</template>

<script>
import { religionCastes } from './constants/religionCastes';
import { guardianSiblingsRelationships } from './constants/guardianSiblingsRelationships';
import { reservationCategories } from './constants/reservationCategories';
import { AdmissionCategories } from './constants/AdmissionCategories';
import { bloodgroups } from './constants/bloodgroups';
import { genders } from './constants/genders';
import { regions } from './constants/regions';
export default {
  props: ["groupInfo", "institutionUserIds", "sortByOrder"],
  data() {
    return {
      religionCastes,
      guardianSiblingsRelationships,
      reservationCategories,
      AdmissionCategories,
      bloodgroups,
      genders,
      regions,
      institutionUsersCompleteData: [],
      institutionuserGuardians: [],
      institutionUsersProfiles: [],
      institutionuserSiblings: [],
      institutionuserAcademicDetails: [],
      userSubGroup: [],
      religions: [],
      castes: [],
      countries: [], // List of countries
      states: [],
      districts: [],
      editProfile: {
        text: "Update All Profiles",
        disabled: false,
      },
      showCasteSelect: false
    };
  },
  async created() {
    this.prepareRegions();
    this.prepareReligionCastes();
    await Promise.all([
      this.getSubGroup(),
      this.prepareUserProfileFullDetails(),
    ]);
  },
  methods: {
    addGuardian(profileIndex) {
      // Create a new empty guardian object
      const newGuardian = {
        id: null,
        name: '',
        relationship: '',
        occupation: '',
        education: '',
        annual_income: null,
        phone_number: '',
        email: ''
      };

      // Retrieve guardians array or initialize if it doesn't exist
      this.institutionUsersCompleteData[profileIndex].guardians = this.institutionUsersCompleteData[profileIndex].guardians || [];

      // Add new guardian
      this.institutionUsersCompleteData[profileIndex].guardians.push(newGuardian);

      // Force Vue to re-render
      this.$forceUpdate();
    },

    removeGuardian(profileIndex, gIndex) {
      const guardians = this.institutionUsersCompleteData[profileIndex].guardians;
      guardians.splice(gIndex, 1);
      this.$set(this.institutionUsersCompleteData[profileIndex], 'guardians', guardians);
      this.$forceUpdate(); // Ensure UI reflects changes
    },
    addSiblings(profileIndex) {
      // Create a new empty sibling object
      const newSibling = {
        id: null,
        name: '',
        relationship: '',
        occupation: '',
        education: '',
        annual_income: null,
        phone_number: '',
        email: ''
      };

      // Retrieve siblings array or initialize if it doesn't exist
      this.institutionUsersCompleteData[profileIndex].siblings = this.institutionUsersCompleteData[profileIndex].siblings || [];

      // Add new sibling
      this.institutionUsersCompleteData[profileIndex].siblings.push(newSibling);

      // Force Vue to re-render
      this.$forceUpdate();
    },

    removeSiblings(profileIndex, sIndex) {
      const siblings = this.institutionUsersCompleteData[profileIndex].siblings;
      siblings.splice(sIndex, 1);
      this.$set(this.institutionUsersCompleteData[profileIndex], 'siblings', siblings);
      this.$forceUpdate(); // Ensure UI reflects changes
    },

    async updateProfiles() {
      this.editProfile.text = "Please Wait...";
      this.editProfile.disabled = true;

      const fieldsToInclude = [
        'id', 'first_name', 'last_name', 'email', 'gender', 'mobile',
        'birth_date',
        'admission_no', 'last_institution', 'roll_number',
        'register_no', 'district_of_institution_last_attended',
        'code_of_institution_last_attended', 'aadhaar_card_no', 'date_of_joining',
        'entrance_rank', 'guardian_email', 'guardian_name', 'guardian_relationship', 'guardian_education', 'guardian_occupation',
        'guardian_annual_income', 'guardian_mobile', 'sibling_name', 'sibling_relationship', 'sibling_education',
        'sibling_occupation', 'sibling_annual_income', 'sibling_mobile',
        'annual_income', 'institution_name', 'category_of_admission', 'reservation_category',
        'religion', 'caste', 'blood_group', 'house_name_communication_address',
        'town_communication_address', 'pincode_communication_address',
        'country_communication_address', 'state_communication_address',
        'district_communication_address', 'house_name_permanent_address',
        'town_permanent_address', 'pincode_permanent_address',
        'country_permanent_address', 'state_permanent_address',
        'district_permanent_address',
        'pincode_communication_address', 'country_communication_address',
        'state_communication_address', 'district_communication_address', 'date_of_joining',
        'admission_no', 'entrance_rank', 'guardians', 'siblings', 'academicArray'
      ];

      const postData = this.institutionUsersCompleteData.map(profile => {
        let data = {};
        fieldsToInclude.forEach(field => {
          data[field] = profile[field];
        });
        return data;
      });

      const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroups/${this.groupInfo.id}/users/update`;

      try {
        await this.$axios.post(url, {
          usersubgroupusers: postData
        });
        this.$toast.success("Students data updated successfully", {
          position: "top",
          duration: 3000,
        });
      } catch (error) {
        console.error("Update failed:", error.response || error);
        this.$toast.error("Failed to update students data, please try again.", {
          position: "top",
          duration: 3000,
        });
      }
      this.editProfile.disabled = false;
      this.editProfile.text = "Update All Profiles";
      this.$forceUpdate();
    },

    async prepareUserProfileFullDetails() {
      this.fetchData = true;
      let url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroupusers/profileindex`;
      let params = {
        usersubgroupId: this.groupInfo.id,
        institutionUserIds: this.institutionUserIds,
      };
      try {
        const response = await this.$axios.post(url, params)
        this.institutionUsersCompleteData = response.data;
        this.institutionUsersCompleteData.forEach((data) => {
          // Save each field in profileData separately
          if (data.profile) {
            data.last_institution = data.profile.last_institution || null;
            data.code_of_institution_last_attended = data.profile.code_of_institution_last_attended || null;
            data.aadhaar_card_no = data.profile.aadhaar_card_no || null;
            data.date_of_joining = data.profile.date_of_joining || null;
            data.entrance_rank = data.profile.entrance_rank || null;
            data.religion = data.profile.religion || null;
            data.caste = data.profile.caste || null;
            data.category_of_admission = data.profile.category_of_admission || null;
            data.reservation_category = data.profile.reservation_category || null;
            data.blood_group = data.profile.blood_group || null;
            data.house_name_communication_address = data.profile.house_name_communication_address || null;
            data.town_communication_address = data.profile.town_communication_address || null;
            data.pincode_communication_address = data.profile.pincode_communication_address || null;
            data.country_communication_address = data.profile.country_communication_address || null;
            data.state_communication_address = data.profile.state_communication_address || null;
            data.district_communication_address = data.profile.district_communication_address || null;
            data.house_name_permanent_address = data.profile.house_name_permanent_address || null;
            data.town_permanent_address = data.profile.town_permanent_address || null;
            data.pincode_permanent_address = data.profile.pincode_permanent_address || null;
            data.country_permanent_address = data.profile.country_permanent_address || null;
            data.state_permanent_address = data.profile.state_permanent_address || null;
            data.district_permanent_address = data.profile.district_permanent_address || null;
          }
        });
      } catch {
        this.$toast.error("Failed to load students data, please try again.", {
          position: "top",
          duration: 3000,
        });
        this.fetchData = false;
      }
      this.fetchData = false;
    },


    // Prepare religion and caste data
    prepareReligionCastes() {
      this.religions = [];
      this.castes = [];
      for (const [religion, data] of Object.entries(this.religionCastes)) {
        this.religions.push({
          value: data.value,
          text: religion,
        });
        // Add castes to the castes array for the specific religion
        data.castes.forEach(caste => {
          this.castes.push({
            value: caste.value,
            text: caste.name,
          });
        });
      }
    },

    // Update castes based on the selected religion
    updateCastes(index) {
      const selectedReligion = this.institutionUsersCompleteData[index].religion.toUpperCase();
      // If no religion is selected, reset the castes
      if (!selectedReligion) {
        this.$set(this.institutionUsersCompleteData[index], "castes", []);
        return;
      }
      // Get the castes for the selected religion
      const religionData = this.religionCastes[selectedReligion];
      if (!religionData || !religionData.castes) {
        this.$set(this.institutionUsersCompleteData[index], "castes", []);
        return;
      }
      // Filter the castes based on the selected religion
      const filteredCastes = religionData.castes.map(caste => ({
        value: caste.value,
        text: caste.name,
      }));
      // Update the castes list for this specific index
      this.$set(this.institutionUsersCompleteData[index], "castes", filteredCastes);
    },

    updateCommunicationStates(index) {
      const countrySlug = this.institutionUsersCompleteData[index].country_communication_address;
      // If country is not India, set "N/A" for communication states and districts
      if (countrySlug && countrySlug.toUpperCase() !== 'INDIA') {
        this.$set(this.institutionUsersCompleteData[index], "communicationStates", [{ value: 'N/A', text: 'N/A' }]);
        this.$set(this.institutionUsersCompleteData[index], "communicationdistricts", [{ value: 'N/A', text: 'N/A' }]);
        return;
      }
      if (!countrySlug) {
        this.$set(this.institutionUsersCompleteData[index], "communicationStates", []);
        return;
      }
      // Find the region based on the country slug
      const region = this.regions.find((r) => r.slug.toUpperCase() === countrySlug.toUpperCase());
      if (!region || !region.states) {
        this.$set(this.institutionUsersCompleteData[index], "communicationStates", []);
        return;
      }
      // Map states to have value (slug) and text (name)
      const states = region.states.map((state) => ({
        value: state.slug,
        text: state.name
      }));
      this.$set(this.institutionUsersCompleteData[index], "communicationStates", states);
      this.$set(this.institutionUsersCompleteData[index], "communicationdistricts", []);  // Reset districts
      this.$forceUpdate();
    },

    updateCommunicationDistricts(index) {
      const countrySlug = this.institutionUsersCompleteData[index].country_communication_address?.toUpperCase();
      const stateSlug = this.institutionUsersCompleteData[index].state_communication_address?.toUpperCase();
      // If country is not India, set "N/A" for communication districts
      if (countrySlug && countrySlug !== 'INDIA') {
        this.$set(this.institutionUsersCompleteData[index], "communicationdistricts", [{ value: 'N/A', text: 'N/A' }]);
        return;
      }
      // Validate country and state
      if (!countrySlug || !stateSlug) {
        this.$set(this.institutionUsersCompleteData[index], "communicationdistricts", []);
        return;
      }
      // Find the region and state based on slugs
      const region = this.regions.find((r) => r.slug.toUpperCase() === countrySlug);
      if (!region || !region.states) {
        this.$set(this.institutionUsersCompleteData[index], "communicationdistricts", []);
        return;
      }
      const state = region.states.find((s) => s.slug.toUpperCase() === stateSlug);
      if (!state || !state.districts) {
        this.$set(this.institutionUsersCompleteData[index], "communicationdistricts", []);
        return;
      }
      // Map districts to have value (slug) and text (name)
      const districts = state.districts.map((district) => ({
        value: district.slug,
        text: district.name
      }));
      this.$set(this.institutionUsersCompleteData[index], "communicationdistricts", districts);
      this.$forceUpdate();
    },

    updatePermanentStates(index) {
      const countrySlug = this.institutionUsersCompleteData[index].country_permanent_address;
      // If country is not India, set "N/A" for permanent states and districts
      if (countrySlug && countrySlug.toUpperCase() !== 'INDIA') {
        this.$set(this.institutionUsersCompleteData[index], "permanentStates", [{ value: 'N/A', text: 'N/A' }]);
        this.$set(this.institutionUsersCompleteData[index], "permanentdistricts", [{ value: 'N/A', text: 'N/A' }]);
        return;
      }
      if (!countrySlug) {
        this.$set(this.institutionUsersCompleteData[index], "permanentStates", []);
        return;
      }
      // Find the region based on the country slug
      const region = this.regions.find((r) => r.slug.toUpperCase() === countrySlug.toUpperCase());
      if (!region || !region.states) {
        this.$set(this.institutionUsersCompleteData[index], "permanentStates", []);
        return;
      }
      // Map states to have value (slug) and text (name)
      const states = region.states.map((state) => ({
        value: state.slug,
        text: state.name
      }));
      this.$set(this.institutionUsersCompleteData[index], "permanentStates", states);
      this.$set(this.institutionUsersCompleteData[index], "permanentdistricts", []);  // Reset districts
      this.$forceUpdate();
    },

    updatePermanentDistricts(index) {
      const countrySlug = this.institutionUsersCompleteData[index].country_permanent_address?.toUpperCase();
      const stateSlug = this.institutionUsersCompleteData[index].state_permanent_address?.toUpperCase();
      // If country is not India, set "N/A" for permanent districts
      if (countrySlug && countrySlug !== 'INDIA') {
        this.$set(this.institutionUsersCompleteData[index], "permanentdistricts", [{ value: 'N/A', text: 'N/A' }]);
        return;
      }
      // Validate country and state
      if (!countrySlug || !stateSlug) {
        this.$set(this.institutionUsersCompleteData[index], "permanentdistricts", []);
        return;
      }
      // Find the region and state based on slugs
      const region = this.regions.find((r) => r.slug.toUpperCase() === countrySlug);
      if (!region || !region.states) {
        this.$set(this.institutionUsersCompleteData[index], "permanentdistricts", []);
        return;
      }
      const state = region.states.find((s) => s.slug.toUpperCase() === stateSlug);
      if (!state || !state.districts) {
        this.$set(this.institutionUsersCompleteData[index], "permanentdistricts", []);
        return;
      }
      // Map districts to have value (slug) and text (name)
      const districts = state.districts.map((district) => ({
        value: district.slug,
        text: district.name
      }));
      this.$set(this.institutionUsersCompleteData[index], "permanentdistricts", districts);
      this.$forceUpdate();
    },

    prepareRegions() {
      // Populate countries array from the regions data
      this.countries = this.regions.map((region) => ({
        value: region.slug,  // Using slug as value for consistency
        text: region.name,   // Using name as text for display
      }));
      // Initialize states and districts arrays
      this.states = [];
      this.districts = [];
      // Loop through regions and populate states and districts
      this.regions.forEach((region) => {
        if (region.states) { // Check if region.states is defined
          region.states.forEach((state) => {
            // Add state to states array
            this.states.push({
              value: state.slug, // Using slug for state
              text: state.name,  // Using name for state
            });
            if (state.districts) { // Check if state.districts is defined
              // Loop through districts in the state
              state.districts.forEach((district) => {
                // Add district to districts array
                this.districts.push({
                  value: district.slug, // Using slug for district
                  text: district.name,  // Using name for district
                });
              });
            }
          });
        }
      });
      this.$forceUpdate();
    },

    async getSubGroup() {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroups/${this.groupInfo.id}?all_data=1`;
      try {
        const response = await this.$axios.get(url);
        this.userSubGroup = response.data;
      } catch (error) {
        console.error(error);
      }
    },

  }
};
</script>
<style scoped>
.fixed-edit-options {
  position: fixed;
  top: 0;
  /* Or bottom: 0; to fix it at the bottom */
  width: 100%;
  background-color: white;
  /* Ensure it's visible and distinguishable */
  z-index: 1000;
  /* Keep it above other elements */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  /* Optional: Add shadow for better visibility */
  padding: 10px 0;
  /* Optional: Add some padding */
}
</style>